import { CAFETERIA_MASTER_LIST } from "../../actionTypes/admin";

const intialState = {
  cafeteriaMasterList: [],
};

export default function CafeteriaReducers(state = intialState, action) {
  switch (action.type) {

    case CAFETERIA_MASTER_LIST:
      return { ...state, cafeteriaMasterList: action.payload };

    default:
      return state;
  }
}
